import React from 'react'
import SimpleAccordion from '../../ui_reusable/SimpleAccordion'
import UniversalLoader from '../../ui_reusable/UniversalLoader'
import FAQAccordion from '../ui_reusable/FAQAccordion'
// Import the generated React Query hook and types
import { useLearningsRetrieve } from '../../../api/generated/endpoints/learning/learning'
// Import Zod schema for runtime validation
import { learningsRetrieveResponse } from '../../../api/generated/validation/learning/learning.zod'
// Import our enhanced validation utility
import { validateAndLog } from '../../../utils/zodDebugger'

import { FAQContainer } from '../ui_reusable/styles/FAQ.styles'

const FAQPage: React.FC = () => {
  // Use the generated React Query hook for type-safe API calls
  const {
    data: learningData,
    isLoading,
    isError,
    error,
  } = useLearningsRetrieve({
    query: {
      staleTime: 0,
      gcTime: 0,
    },
  })

  // Runtime validation with enhanced debugging (one-liner)
  const validatedData = validateAndLog(
    learningsRetrieveResponse,
    learningData,
    'FAQPage',
  )

  const faqData = Array.isArray(validatedData?.data?.faq)
    ? validatedData!.data!.faq
    : []

  return (
    <>
      <SimpleAccordion id="showFAQPageAccordion" defaultActiveKey={['1']}>
        <SimpleAccordion.Panel header="FAQ" eventKey="1" noCollapse>
          <FAQContainer>
            <UniversalLoader
              show={isLoading}
              content="Loading FAQ content..."
            />
            {isError && (
              <div>
                Error:{' '}
                {error instanceof Error
                  ? error.message
                  : 'Failed to load FAQ content'}
              </div>
            )}
            {!isLoading && !isError && faqData.length === 0 && (
              <div>No FAQ items available.</div>
            )}
            {!isLoading && !isError && faqData.length > 0 && (
              <FAQAccordion id="showFAQAccordion">
                {faqData.map((elem: any, i: number) => (
                  <FAQAccordion.Panel
                    key={`faq-${elem.id}-${i}`}
                    eventKey={`faq-${elem.id}`}
                    header={elem.question}
                    text={elem.answer}
                    showActions={false}
                  />
                ))}
              </FAQAccordion>
            )}
          </FAQContainer>
        </SimpleAccordion.Panel>
      </SimpleAccordion>
    </>
  )
}

export default FAQPage
